function ReactDesktopMenu(props) {
  const [menuItems, setMenuItems] = React.useState({});
  const [menHover, setMenHover] = React.useState({
    hovered: false,
    displayed: false
  });
  const [womenHover, setWomenHover] = React.useState({
    hovered: false,
    displayed: false
  });
  const [dealsHover, setDealsHover] = React.useState({
    hovered: false,
    displayed: false
  });
  const [width, setWidth] = React.useState(window.innerWidth);
  const menVideoSrc = "https://cdn.shopify.com/videos/c/o/v/9f120715b499415c95bbcd86c21d1d94.mp4";
  const womenVideoSrc = "https://cdn.shopify.com/videos/c/o/v/af92de86cdf2419fbcb949787170baba.mp4";
  const saleMenVideoSrc = "https://cdn.shopify.com/videos/c/o/v/eaa9b51244304600bb9a2899932bf792.mp4";
  const saleWomenVideoSrc = "https://cdn.shopify.com/videos/c/o/v/4f8c3a5a98e644a99fc92a2f6425843e.mp4";
  const handleMenOver = () => {
    setMenHover({
      hovered: true,
      displayed: true
    });
  };
  const handleMenOut = () => {
    setMenHover({
      ...menHover,
      hovered: false
    });
  };
  const handleWomeOver = () => {
    setWomenHover({
      hovered: true,
      displayed: true
    });
  };
  const handleWomenOut = () => {
    setWomenHover({
      ...womenHover,
      hovered: false
    });
  };
  const handleDealsOver = () => {
    setDealsHover({
      hovered: true,
      displayed: true
    });
  };
  const handleDealsOut = () => {
    setDealsHover({
      ...dealsHover,
      hovered: false
    });
  };

  // Fetching Menu Items from JSON
  React.useEffect(() => {
    fetch(props.menuItems).then(response => response.json()).then(data => setMenuItems(data));
  }, []);
  React.useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return /*#__PURE__*/React.createElement("nav", null, width > 1350 && /*#__PURE__*/React.createElement("div", {
    className: "collapseNav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapseOptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapseDropdown",
    onMouseOver: handleMenOver,
    onMouseOut: handleMenOut
  }, /*#__PURE__*/React.createElement("a", {
    className: "toggleDropdown",
    href: "/pages/mens",
    "aria-label": "Hover over for menu dropdown"
  }, "MEN", /*#__PURE__*/React.createElement("img", {
    className: "dropdownIcon",
    width: "38px",
    height: "31px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/dropdown-black.png?v=1679515738",
    alt: "icondrop"
  })), menHover.displayed == true ? /*#__PURE__*/React.createElement("div", {
    className: "desktopHeader",
    style: {
      visibility: menHover.hovered ? "visible" : "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "MEN"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.men && menuItems.men.map((item, index) => item.children.length === 0 && item.typeOfCard !== "custom" ? /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("a", {
    style: item.ztyle,
    className: `hover-underline-animation ${item.typeOfCard}`,
    href: item.link
  }, item.caption)) : null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "COLLECTIONS"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.men && menuItems.men.filter(item => item.caption.includes("COLLECTIONS")).map((x, i) => x.children.map((y, z) => {
    const athletes = ["DUSTIN POIRIER", "DEREK LUNSFORD", "REGAN GRIMES"];
    const isAthleteItem = athletes.some(name => y.caption.includes(name));
    if (!isAthleteItem && y.typeOfCard === "inner") {
      return /*#__PURE__*/React.createElement("li", {
        key: z
      }, /*#__PURE__*/React.createElement("a", {
        className: `hover-underline-animation ${y.typeOfCard}`,
        "aria-label": "Menu options",
        href: y.link
      }, y.caption));
    }
    return null;
  }))), /*#__PURE__*/React.createElement("h3", {
    className: "athleteTitle"
  }, "ATHLETES"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.men && menuItems.men.filter(item => item.caption.includes("COLLECTIONS")).map((x, i) => x.children.map((y, z) => {
    const athletes = ["DUSTIN POIRIER", "DEREK LUNSFORD", "REGAN GRIMES"];
    const isAthleteItem = athletes.some(name => y.caption.includes(name));
    if (isAthleteItem && y.typeOfCard === "inner") {
      return /*#__PURE__*/React.createElement("li", {
        key: z
      }, /*#__PURE__*/React.createElement("a", {
        className: `hover-underline-animation ${y.typeOfCard}`,
        "aria-label": "Menu options",
        href: y.link
      }, y.caption));
    }
    return null;
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "SHOP BY CATEGORY"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.men && menuItems.men.filter(item => item.caption.includes("CATEGORIES")).map((x, i) => x.children.map((y, z) => y.typeOfCard !== "custom" ? /*#__PURE__*/React.createElement("li", {
    key: z
  }, y.image.length > 0 ? /*#__PURE__*/React.createElement("a", {
    className: "hover-underline-animation",
    "aria-label": "Menu options",
    href: y.link
  }, y.caption) : /*#__PURE__*/React.createElement("a", {
    href: y.link,
    className: "title-li hover-underline-animation",
    "aria-label": "Menu options"
  }, y.caption)) : null)))), /*#__PURE__*/React.createElement("a", {
    href: "/collections/train-like-a-freak",
    "aria-label": "link to gym-to-street collection"
  }, /*#__PURE__*/React.createElement("video", {
    loop: true,
    className: "headerVideo",
    autoPlay: true,
    muted: true
  }, /*#__PURE__*/React.createElement("source", {
    src: menVideoSrc,
    alt: "TLF models wearing gym gear",
    kind: "captions",
    srclang: "en",
    label: "english_captions"
  })))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "collapseOptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapseDropdown",
    onMouseOver: handleWomeOver,
    onMouseOut: handleWomenOut
  }, /*#__PURE__*/React.createElement("a", {
    className: "toggleDropdown",
    href: "/pages/womens"
  }, "WOMEN", /*#__PURE__*/React.createElement("img", {
    className: "dropdownIcon",
    width: "38px",
    height: "31px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/dropdown-black.png?v=1679515738",
    alt: "icondrop"
  })), womenHover.displayed == true ? /*#__PURE__*/React.createElement("div", {
    className: "desktopHeader",
    style: {
      visibility: womenHover.hovered ? "visible" : "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "navigation-menu"
  }, /*#__PURE__*/React.createElement("h3", null, "WOMEN"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.women && menuItems.women.map((item, index) => item.children.length == 0 && item.typeOfCard != "custom" ? /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("a", {
    style: item.ztyle,
    className: `hover-underline-animation ${item.typeOfCard}`,
    href: item.link
  }, item.caption)) : null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "COLLECTIONS"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.women && menuItems.women.filter(item => item.caption.includes("COLLECTIONS")).map((x, i) => x.children.map((y, z) => y.typeOfCard == "inner" ? /*#__PURE__*/React.createElement("li", {
    key: z
  }, /*#__PURE__*/React.createElement("a", {
    className: "hover-underline-animation",
    href: y.link
  }, y.caption)) : null)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "SHOP BY CATEGORY"), /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, menuItems.women && menuItems.women.filter(item => item.caption.includes("CATEGORIES")).map((x, i) => x.children.map((y, z) => y.typeOfCard != "custom" ? /*#__PURE__*/React.createElement("li", {
    key: z
  }, y.image.length > 0 ? /*#__PURE__*/React.createElement("a", {
    className: "hover-underline-animation",
    href: y.link
  }, y.caption) : /*#__PURE__*/React.createElement("a", {
    href: y.link,
    className: "title-li hover-underline-animation"
  }, y.caption)) : null)))), /*#__PURE__*/React.createElement("a", {
    href: "/collections/womens-seamless-collection",
    "aria-label": "Video of womens outlet click to view"
  }, /*#__PURE__*/React.createElement("video", {
    loop: true,
    className: "headerVideo",
    autoPlay: true,
    muted: true
  }, /*#__PURE__*/React.createElement("source", {
    src: womenVideoSrc,
    alt: "TLF models wearing gym gear",
    kind: "captions",
    srclang: "en",
    label: "english_captions"
  })))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "collapseOptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdownSale",
    onMouseOver: handleDealsOver,
    onMouseOut: handleDealsOut
  }, /*#__PURE__*/React.createElement("div", {
    className: "toggleDropdown"
  }, "OVERSTOCK SALE", /*#__PURE__*/React.createElement("img", {
    className: "dropdownIcon",
    width: "38px",
    height: "31px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/dropdown-black.png?v=1679515738",
    alt: "icondrop"
  })), dealsHover.displayed == true ? /*#__PURE__*/React.createElement("div", {
    className: "desktopHeader saleDesktopHeader",
    style: {
      visibility: dealsHover.hovered ? "visible" : "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoContainer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "navigation-menu saleClass"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "saleTitle"
  }, "MEN"), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/mens-outlet",
    className: "hover-underline-animation",
    "aria-label": "All mens outlet"
  }, "All Products")), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/mens-outlet-tops",
    className: "hover-underline-animation",
    "aria-label": "Mens outlet tops"
  }, "Tops")), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/mens-outlet-bottoms",
    className: "hover-underline-animation",
    "aria-label": "Mens outlet bottoms"
  }, "Bottoms")))), /*#__PURE__*/React.createElement("div", {
    className: "navigation-menu saleClass lineHere"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menuHeader"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "saleTitle"
  }, "WOMEN"), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/womens-outlet",
    className: "hover-underline-animation",
    "aria-label": "All womens outlet"
  }, "All Products")), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/womens-outlet-tops",
    className: "hover-underline-animation",
    "aria-label": "Womens outlet tops"
  }, "Tops")), /*#__PURE__*/React.createElement("li", {
    className: "salesLi"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/collections/womens-outlet-bottoms",
    className: "hover-underline-animation",
    "aria-label": "Womens outlet bottoms"
  }, "Bottoms")))), /*#__PURE__*/React.createElement("div", {
    className: "videoContainer"
  })) : null))));
}
const domContainerForReactDesktopMenu = document.querySelector('#reactDesktopMenu');
const rootForReactDesktopMenu = ReactDOM.createRoot(domContainerForReactDesktopMenu);
rootForReactDesktopMenu.render( /*#__PURE__*/React.createElement(ReactDesktopMenu, {
  menuItems: domContainerForReactDesktopMenu.dataset.menuItems
}));
